// src/utils/imageToBase64.ts
export const imageToBase64 = (imagePath: string): Promise<string> => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = imagePath;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.drawImage(img, 0, 0);
        const base64String = canvas.toDataURL('image/png');
        resolve(base64String);
      }
    };
  });
};
